import styles from './MenuItemTile.module.scss'

export interface MenuItemTileProps {
  name: string
  description: string
  price: string
  dishImage?: string
}

function MenuItemTile(props: MenuItemTileProps) {
  const { name, description, price, dishImage } = props
  return (
    <div className={styles.menuItemTileContainer}>
      <div className={styles.menuItemTileTextGroup}>
        <p className={`body-bold-medium ${styles.menuItemTileTitle}`}>{name}</p>
        <p className={`body-medium ${styles.menuItemTileDescription}`}>
          {description}
        </p>
        <p className={`body-medium ${styles.menuItemTilePrice}`}>{price}</p>
      </div>
      {dishImage ? (
        <div className={styles.menuItemTileImagePlaceholder}>
          <img
            src={dishImage}
            alt="burger_image"
            className={styles.menuItemTileImage}
          />
          <div />
        </div>
      ) : null}
    </div>
  )
}

export default MenuItemTile
